import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const LOGGED_IN_FAIL = 'LOGGED_IN_FAIL';

export const useOnCredentialsLoginError = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: any) => {
        const event = new CustomEvent(LOGGED_IN_FAIL, { detail: [detail] });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('auth:credentials:login:failed', handleEvent);

        return () => publicEventsAPIService.off('auth:credentials:login:failed', handleEvent);
    }, [handleEvent]);
};
